// Copy for the lock shown on anything a partner pushed into this account from their Library.
//
// The lock means two different things depending on whether the partner has handed editing
// over, so the tooltip has to say which: "Managed by" reads as "not yours to change",
// "Added by" as "they set it up, but it's yours now".
//
// Shared so the rules table and the analytics report card can never drift apart on wording.
export const partnerManagedTooltip = (item: { partnerName?: string | null, canClientEdit?: boolean }) => {
  const partner = item.partnerName?.trim() || 'your partner'
  return item.canClientEdit === false ? `Managed by ${partner}` : `Added by ${partner}`
}
